import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { CommonActions, AlertType } from '@wajeez-web/stores/common';

import { SelectionFlowInput } from './types';

export const getFRlowReader: ApiMethod<void, Server.FlowOutput, any> = async (
  _,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);
    const response = await client.flows_reader_get_V1();
    if (response.success && response.data) {
      return response.data;
    }
    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getFlowsDatatable: ApiMethod<
  Server.FlowDatatable,
  Server.TableOfFlowColumns
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createFlow: ApiMethod<Server.CreateFlowInput, number> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createFlowV2: ApiMethod<Server.CreateFlowInput2, number> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_post_V2(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const editFlow: ApiMethod<Server.UpdateFlowInput, void> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_put_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const editFlowV2: ApiMethod<Server.UpdateFlowInput2, number> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_put_V2(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const setFlowContentEntityTypeNavigations: ApiMethod<
  Server.SetFlowContentEntityTypeNavigationsInput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_set_post_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getFlowDetailsById: ApiMethod<number, Server.FlowOutput> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_byId_get_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getFlowDetailsByIdV2: ApiMethod<
  number,
  Server.FlowOutput2
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_byId_get_V2(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const cloneFlow: ApiMethod<Server.CloneFlowInput, number, void> = async (
  data,
  { dispatch, rejectWithValue }
) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_clone_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getFlowsLookups: ApiMethod<
  { SearchString?: string },
  Server.FlowOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const response = await client.admin_Flows_lookups_get_V1(data.SearchString);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getSelectionFlow: ApiMethod<
  Partial<SelectionFlowInput>,
  Server.FlowOutput2,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_Flows_Client(undefined, contentClient);

    const {
      groupState,
      nowDateTime,
      planIds,
      platform,
      readerId,
      iSOThreeDigitCountryCode,
      appVersionMajor,
      appVersionMiddle,
      appVersionMinor,
      languageId
    } = data;

    const response = await client.flows_getFlow_get_V2(
      groupState,
      nowDateTime,
      planIds,
      // TODO: Fill this with the correct values
      [],
      platform,
      readerId,
      iSOThreeDigitCountryCode,
      appVersionMajor,
      appVersionMiddle,
      appVersionMinor,
      languageId
    );

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};
